import { useRef } from 'react';
import copyIcon from '~/assets/img/copy.svg';
import copyIconShare from '~/assets/img/share-hover.svg';
import { getFullUrl } from '~/helpers/url';

const Code = ({ children }) => {
  const code = useRef();
  const selectCode = () => code.current.select();
  const copyToClipboard = (e) => {
    selectCode();
    document.execCommand('copy');
    e.target.classList.add('used');
  };
  const mobileShare = async () => {
    if (navigator.share) {
      // Safari, Chrome for Android only
      try {
        await navigator?.share({
          title: 'Proxy for Packagist',
          text: 'Speed up downloading Composer dependencies by 90% thanks to global CDN. It works also for all packages from packagist.org',
          url: getFullUrl('/proxy'),
        });
      } catch (error) {
        // suppress all
      }
    }
  };

  return (
    <div className="pre-container">
      <pre className="code-snippet">
        <textarea
          className="copy-source"
          readOnly
          ref={code}
          value={children}
          aria-label="Code snippet"
        />
        <code className="code">{children}</code>
      </pre>
      <a className="copy-link" onClick={copyToClipboard}>
        <img className="copy-pic" src={copyIcon} alt="Copy to clipboard" />
      </a>
      <a className="copy-link __share" onClick={mobileShare}>
        <img className="copy-pic" src={copyIconShare} alt="Share code snippet" />
      </a>
    </div>
  );
};

export default function CodeCaption({ description, children }) {
  return (
    <section className="code-caption">
      <div className="container">
        <p className="text code-desc">
          {description}
        </p>
        <Code>{children}</Code>
      </div>
    </section>
  );
}
